export const ASSETS_URL_FORMATTER_TOKEN = Symbol('ASSETS_URL_FORMATTER_TOKEN');

export interface IAssetsUrlFormatter {
  format(url: string): string;
}
